// extracted by mini-css-extract-plugin
export default {"fontSizeMedium":"28px","fontSizeNormal":"18px","fontSizeBody":"16px","fontSizeButton":"14px","fontSizeSmall":"12px"};